import Swiper from 'swiper/core';

export default class Instagram {
  constructor(swiper) {
    this.dom = {
      swiper,
    };

    this.data = {
      swiperOptions: {
        loop: true,
        speed: 10000,
        centeredSlides: true,
        slidesPerView: 'auto',
        spaceBetween: 24,
        allowTouchMove: false,
        autoplay: {
          delay: 1,
          disableOnInteraction: false,
        },
      },
    };

    this.components = {
      swiper: null,
    };

    this.mount();
  }

  mount() {
    this.initSwiper();
  }

  initSwiper() {
    this.components.swiper = new Swiper(
      this.dom.swiper,
      this.data.swiperOptions,
    );
  }
}
